const projects = [
    {
        title: "QRing",
        description:
            "An application facilitating geofenced QR code scanning as a mechanism for alerting occupants within a residential setting.",
        techStack: ["React", "Firebase", "Express", "Antd"],
        icon: "https://raw.githubusercontent.com/PrajjvalMehra/QRing/main/client/public/Png/512.png",
        repo: "https://github.com/PrajjvalMehra/QRing",
    },
    {
        title: "Gallon",
        description:
            "A dynamic water tracking and reminder mobile application published on the Google Play Store.",
        techStack: ["React Native", "Firebase", "Native Base", "Expo"],
        icon: "https://camo.githubusercontent.com/6271e3cdb47f387af404c0d149dbfa745eddbac1df4f424dbe1b9738d3d178c6/68747470733a2f2f706c61792d6c682e676f6f676c6575736572636f6e74656e742e636f6d2f6b6a613555545f55783130334269323861523470774d6c4579794174376177324a6a416b4164664479765430377536576b6630673834345566565238513458777269493d773234302d683438302d7277",
        repo: "https://github.com/PrajjvalMehra/gallon",

    },
    {
        title: "2D Physics Engine",
        description: "A simple physics engine to resolve collisions in 2D, showcased using air hockey simulation.",
        techStack: ["React", "Javascript", "HTML", "CSS"],
        repo: "https://github.com/PrajjvalMehra/BoringHockey",
    },
    {
        title: "Chat Application",
        description:
            "A chat web application with realtime one:one  and group messaging using Socket.io.",
        techStack: ["React", "CSS", "Socket.io", "Express", "MongoDB"],
        repo: "https://github.com/PrajjvalMehra/mern-socket-chat",
    },
    {
        title: "Discord Bot",
        description:
            "A bot for discord (a voip and chat application) which shows the stats of COVID-19 based on the parameters provided by the user.",
        techStack: ["Node.js", "Discord.js"],
        repo: "https://github.com/PrajjvalMehra/corona-bot",
    },
    {
        title: "Weather Widget",
        description:
            "A simple weather widget which shows the weather of the city provided by the user.",
        techStack: ["React", "Open Weather API", "CSS"],
        repo: "https://github.com/PrajjvalMehra/mern-socket-chat",
    },
];

export { projects };
